import { EventEmitter } from '@angular/core';

export function JSONStringify(object) {
  let cache = [];
  const str = JSON.stringify(
    object,
    // custom replacer fxn - gets around
    // "TypeError: Converting circular structure to JSON"
    function (key, value) {
      if (typeof value === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Circular reference found, discard key
          return;
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    },
    4,
  );
  cache = null; // enable garbage collection
  return str;
}

export class ObservableArray {
  onArrayChanges: EventEmitter<any> = new EventEmitter();
  onRemovedItem: EventEmitter<any> = new EventEmitter();
  onAddedItem: EventEmitter<any> = new EventEmitter();

  onComponentChanges: EventEmitter<any> = new EventEmitter();

  length(): number {
    return this.collection.length;
  }

  private collectionCount: number = 0;
  private isStartup: boolean = true;
  constructor(public array: any[]) {
    this.onComponentChanges.subscribe((data) => {
      this.array = data;
      this.onChanges();
    });
  }

  private collection: any[] = [];
  private subscriptions: any[] = [];

  onChanges(): void {
    const collectionModel = new CollectionModel();
    collectionModel.originalValue = this.collection;
    collectionModel.newValue = this.isStartup ? this.collection : this.array;
    collectionModel.isRecordAdded = this.isAddedItem();
    collectionModel.isRecordRemoved = this.isRemovedItem();

    this.collectionCount = this.collection.length;

    if (this.isAddedItem()) {
      this.onAddedItem.emit(collectionModel);
    }

    if (this.isRemovedItem()) {
      this.onRemovedItem.emit(collectionModel);
    }

    if (this.isChanged()) {
      this.updateCollection();
      this.onArrayChanges.emit(collectionModel);
      this.publish(collectionModel);
      this.isStartup = false;
    }
  }
  private isChanged(): boolean {
    let isChanged = false;
    if (this.array) {
      isChanged = this.array.length !== this.collectionCount;
    }
    return isChanged || this.isStartup;
  }
  private isAddedItem(): boolean {
    let isAddedItem = false;
    if (this.array) {
      isAddedItem = this.array.length > this.collectionCount;
    }
    return isAddedItem;
  }
  private isRemovedItem(): boolean {
    let isRemoved = false;
    if (this.array) {
      isRemoved = this.array.length < this.collectionCount;
    }
    return isRemoved;
  }

  private updateCollection() {
    this.collection = this.array;
  }

  private publish(payload?: any) {
    for (const callback of this.subscriptions) {
      callback(payload);
    }
  }

  subscribe(callback: (payload?: any) => void) {
    this.subscriptions.push(callback);
  }
}

export class CollectionModel {
  originalValue: any[] = [];
  newValue: any[] = [];
  isRecordAdded: boolean = false;
  isRecordRemoved: boolean = false;
}
